import React from "react";
import Modal from "react-modal"; // Ensure you have react-modal installed

const DeleteCategoryModal = ({ isDeleteModalOpen, toggleModal, handleDelete, selectedCategory }) => {
  return (
    <>
      {isDeleteModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
          <div className="relative w-full max-w-md p-4 max-h-full">
            <div className="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
              <div className="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Delete Category</h2>
                <button
                  type="button"
                  onClick={toggleModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              {selectedCategory ? (
                <div className="mt-4">
                  <p className="text-gray-700">
                    Are you sure you want to delete the category "<strong>{selectedCategory.name}</strong>"?
                  </p>
                </div>
              ) : (
                <p className="text-gray-700">No category selected.</p>
              )}
              <div className="mt-6 flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={toggleModal}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDelete}
                  className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteCategoryModal;
